// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ComingSoon_wrapper__3IY_I","backdrop":"ComingSoon_backdrop__1KnSS","title":"ComingSoon_title__3ieMl"};